import constantStyles from "!!sass-variable-loader!Styles/Constants.scss";
import * as React from "react";
import { ScaleLoader } from "react-spinners";

interface IProps {
    color?: string;
}

const Loader: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className="loader-spinner-loading">
        <ScaleLoader color={props.color} />
    </div>
);

Loader.defaultProps = {
    color: constantStyles.primaryColor
};

export default Loader;


// WEBPACK FOOTER //
// ./src/Components/Loading/Loader/Loader.tsx